const config = require('../../config/production.json')
module.exports = {
  ...config
};


// WEBPACK FOOTER //
// ./src/feConfig/production.js